import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import PostRequest from '../../../../service/PostRequest'; 
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';
import './ResetPasswordPage.scss';
import InputPassword from '../../../../components/Widgets/Inputs/InputPassword';

const ResetPasswordPage = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
    const toastBottomCenter = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();
    const resetQuery = new URLSearchParams(location.search).get('query');
    const email = new URLSearchParams(location.search).get('email');

    const passwordMinLength = 8;
    const passwordHasUpperCase = /[A-Z]/;
    const passwordHasLowerCase = /[a-z]/;
    const passwordHasNumber = /\d/;
    const passwordHasSpecialChar = /[@$!%*?&]/;
    const passwordInvalidChar = /[^A-Za-z\d@$!%*?&]/;

    const validatePassword = () => {
        let isValid = true;

        if (!password.trim()) {
            setPasswordError("Password is required");
            isValid = false;
        } else if (password.length < passwordMinLength) {
            setPasswordError(`Password must be at least ${passwordMinLength} characters with special characters`);
            isValid = false;
        } else if (!passwordHasUpperCase.test(password)) {
            setPasswordError("Password must contain at least one uppercase letter");
            isValid = false;
        } else if (!passwordHasLowerCase.test(password)) {
            setPasswordError("Password must contain at least one lowercase letter");
            isValid = false;
        } else if (!passwordHasNumber.test(password)) {
            setPasswordError("Password must contain at least one number");
            isValid = false;
        } else if (!passwordHasSpecialChar.test(password)) {
            setPasswordError("Password must contain at least one special character (@$!%*?&)");
            isValid = false;
        } else if (passwordInvalidChar.test(password)) {
            setPasswordError("Password contains invalid characters");
            isValid = false;
        } else {
            setPasswordError("");
        }

        if (!confirmPassword.trim()) {
            setConfirmPasswordError("Confirm Password is required");
            isValid = false;
        } else if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match");
            isValid = false;
        } else {
            setConfirmPasswordError("");
        }

        return isValid;
    };

    const handleSubmit = async () => {
        if (!validatePassword()) {
            return;
        }

        try {
            const data = {
                email: email,
                password: password,
            };

            setIsWaitingForResponse(true);
            const response = await PostRequest(`auth/reset/password?resetPasswordQuery=${resetQuery}`, data, false);

            setIsWaitingForResponse(false);

            if (response.status === 204) {
                showMessage("Password reset successfully", toastBottomCenter, 'success');
                setTimeout(() => {
                    navigate("/login");
                }, 2000); 
            } else {
                setPasswordError("Failed to reset password. Please try again.");
                showMessage("Failed to reset password", toastBottomCenter, 'danger');
            }
        } catch (error) {
            console.error("Error resetting password:", error);
            setIsWaitingForResponse(false);
            setPasswordError("Failed to reset password. Please try again.");
            showMessage("Error resetting password", toastBottomCenter, 'danger');
        }
    };

    const showMessage = (message, ref, severity) => {
        ref.current.show({ severity: severity, summary: message, detail: message, life: 2000 }); 
    };

    return (
        <div className='ResetPasswordContainer'>
            <div className='Heading'>
                <img src={BOSS_mainlogo} alt="BOSS Logo" />
                <h3>Update Your Password</h3>
            </div>
            <div className='WholeForm'>
                <div className='PasswordInput'>
                    <label>Enter New Password</label>
                    <InputPassword 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        label="Enter Your Password" 
                        errorMessage={passwordError} 
                        style={{ borderColor: passwordError ? 'red' : '' }}
                    />
                    {passwordError && <div style={{color:"red", fontSize:"0.875rem", width:"340px", marginTop:"10px"}}>{passwordError}</div>}
                </div>
                <div className='PasswordInput'>
                    <label>Confirm New Password</label>
                    <InputPassword 
                        value={confirmPassword} 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        label="Confirm Your Password" 
                        errorMessage={confirmPasswordError} 
                        style={{ borderColor: confirmPasswordError ? 'red' : '' }}
                    />
                    {confirmPasswordError && <div className='ErrorText'>{confirmPasswordError}</div>}
                </div>
                <Button 
                    label="Reset Password" 
                    onClick={handleSubmit} 
                    style={{ width: "355px", borderRadius: "40px", margin: "30px 0px" }} 
                    disabled={isWaitingForResponse} 
                    loading={isWaitingForResponse} 
                />
            </div>
            <Toast ref={toastBottomCenter} position="bottom-center" />
        </div>
    );
};

export default ResetPasswordPage;
